import styled from 'styled-components'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${(p) => p.theme.v2.surface.white};
  .list-image {
    width: 86%;
  }
  @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: row;
    margin: 0;
    .list-image {
      width: 120px;
    }
  }
`
const StyledTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    text-align: left;
    margin: 0 16px;
  }
  h4 {
    font-size: ${(p) => p.theme.v2.typography.body.m.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.m.lineHeight};
    font-family: ${(p) => p.theme.v2.font.nantes};
    margin-bottom: 16px;
    @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
      font-size: ${(p) => p.theme.v2.typography.body.xs.fontSize};
      line-height: ${(p) => p.theme.v2.typography.body.xs.lineHeight};
      font-family: ${(p) => p.theme.v2.font.lotaGrotesqueRegular};
      font-weight: 400;
      margin-bottom: 4px;
    }
  }
  p {
    font-size: ${(p) => p.theme.v2.typography.body.xs.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.xs.lineHeight};
    font-family: ${(p) => p.theme.v2.font.lotaGrotesqueLight};
    margin: 0;
    @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
      font-size: ${(p) => p.theme.v2.typography.body.xxs.fontSize};
      line-height: ${(p) => p.theme.v2.typography.body.xxs.lineHeight};
      font-family: ${(p) => p.theme.v2.font.lotaGrotesqueLight};
    }
  }
`

export const FourColumnFeatureCard = ({
  image,
  title,
  description,
}: {
  image: any
  title: string
  description: string
}) => {
  return (
    <StyledContainer>
      {image && <img src={image.src} alt={image.alt} className="list-image" />}
      <StyledTextContainer className="list-text">
        {title && <h4>{title}</h4>}
        {description && <p>{description}</p>}
      </StyledTextContainer>
    </StyledContainer>
  )
}
